module.exports = __webpack_public_path__ + "img/iconSquare.a6ea4c9f.svg";